import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaFornecedores: [],
  fornecedorPesquisa: {
    nome: undefined,
    pagina: 0
  },
  labelQuantidade: '',
  fornecedorSelecionado: {
    id: 0,
    nome: '',
    personalidadeJuridica: 'PESSOA_JURIDICA',
    contasBancarias: []
  }
}

const mutations = {
  atualizarListaFornecedores(state, payload) {
    if(state.fornecedorPesquisa.pagina === 0) {
      state.listaFornecedores = payload.lista;
    } else {
      state.listaFornecedores.push(...payload.lista);
    }

    state.labelQuantidade = payload.quantidade + (payload.quantidade === 1 ? " Fornecedor encontrado" : " Fornecedores encontrados");
  },
  limparFornecedoresListadas(state) {
    state.listaFornecedores = [];
  },
  limparFornecedorPesquisa(state) {
    state.fornecedorPesquisa = {
      nome: undefined,
      pagina: 0
    };
  },
  atualizarFornecedorSelecionado(state, payload) {
    state.fornecedorSelecionado = payload;
  },
  novoFornecedor(state) {
    state.fornecedorSelecionado = {
      id: 0,
      nome: '',
      personalidadeJuridica: 'PESSOA_JURIDICA',
      contasBancarias: []
    }
  }
}

const actions = {
  listarFornecedores(context, payload) {
    return axios.post(URLS.FORNECEDORES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaFornecedores', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('listarFornecedores', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  limparFornecedoresListadas(context) {
    context.commit('limparFornecedoresListadas');
  },
  limparFornecedorPesquisa(context){
    context.commit('limparFornecedorPesquisa');
  },
  recuperarFornecedor(context, payload) {
    return axios.post(URLS.FORNECEDORES_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFornecedorSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarFornecedor', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  novoFornecedor(context) {
    context.commit('novoFornecedor');
  },
  gravarFornecedor(context, payload) {
    return axios.post(URLS.FORNECEDORES_GRAVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarFornecedorSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gravarFornecedor', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  removerFornecedor(context, payload) {
    return axios.post(URLS.FORNECEDORES_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novoFornecedor');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('removerFornecedor', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  gravarConta(context, payload){
    payload.fornecedor = { id: context.state.fornecedorSelecionado.id };
    return axios.post(URLS.FORNECEDORES_GRAVAR_CONTA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFornecedorSelecionado', response.data.item)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarConta', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  removerConta(context, payload) {
    payload.fornecedor = { id: context.state.fornecedorSelecionado.id }
    return axios.post(URLS.FORNECEDORES_REMOVER_CONTA, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFornecedorSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA": 
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerConta', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },


}

export default {
  state,
  mutations,
  actions
}